import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { AppState } from '../state/root/';
import { selectExperimentalMode } from '../state/settings/settings.selectors';

export const experimentalGuard: CanActivateFn = () => {
    const store: Store<AppState> = inject(Store<AppState>);
    return store.pipe(
        select(selectExperimentalMode),
        map(experimental => {
            return experimental;
        })
    );
};
